import { css, type Theme } from "@emotion/react";
import { borders } from "aviary-tokens";

export const dropDown = css`
  width: 100%;
`;

export const searchBarInput = (theme: Theme) => css`
  background-color: ${theme.system.backgroundBase};
`;

export const ds4SearchBox = (theme: Theme, error: boolean) => css`
  background-color: ${theme.system.backgroundBase};
  border: 1px solid ${theme.system.borderBase};
  border-bottom-left-radius: ${borders.radiusBase};
  border-bottom-right-radius: ${borders.radiusBase};
  border-top-right-radius: ${borders.radiusBase};
  border-top-left-radius: ${borders.radiusBase};

  :hover,
  :active,
  :focus-within,
  :focus {
    border: ${error
      ? `1px solid ${theme.input.borderError}`
      : `1px solid ${theme.system.borderHover}`};
    box-shadow: none;
    transition-delay: -1s;

    > input {
      transition-delay: -1s;
    }

    svg path {
      fill: ${theme.input.textBase};
    }
  }
`;
